import { UploadStickerButtonField } from './UploadStickerButtonField'
import { withUploadStickerButtonField } from './withUploadStickerButtonField'

const ConnectedUploadStickerButtonField = withUploadStickerButtonField(
  UploadStickerButtonField
)

export { ConnectedUploadStickerButtonField as UploadStickerButtonField }
